import React, { Component } from "react";
import {
  Container,
  Form,
  Button,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardLink,
  CardTitle,
  CardSubtitle,
  CardGroup,
  CardDeck,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  UncontrolledCarousel
} from "reactstrap";
import "./minigame.css";

class Minigame extends Component {
  render() {
    return (
      <div>
        <Container className="comming">
          <Form className="boxminigame">
            <h1 className="textTest">มินิเกมส์<h1 className="commingsoon">comming Soon</h1></h1>
            <br></br>
            
            <CardDeck className="boxgame">
              <Card className="boxgame2">
                <CardBody >
                  <CardTitle>JIGSOW</CardTitle>
                  <CardSubtitle>เกมส์สไตล์ต่อจิ๊กซอตามภาพที่ได้</CardSubtitle>
                </CardBody>
                <img
                  width="60%"
                  src="/img/gradient-845701_960_720.jpg"
                />
                <CardBody>
                  <CardText>
                    เกมส์แนวเรียงคำให้ให้ความหลายโดนใช้คำที่อิงประวัติศาสตร์ เพื่อเพิ่มความสนุกให้กับการเรียนรู้ิชาประวัติศาสตร์
                  </CardText>
                  <CardLink outline color="primary" href="http://localhost:50000/">Start</CardLink>
                  <CardLink href="#">คำอธิบาย</CardLink>
                </CardBody>
              </Card>

              <Card className="boxgame3">
                <CardBody >
                  <CardTitle>Project 072</CardTitle>
                  <CardSubtitle>เกมส์16บิต สไตล์เนื้อเรื่อง</CardSubtitle>
                </CardBody>
                <img
                  width="80%"
                  src="/img/หห.JPG"
                />
                <CardBody>
                  <CardText>
                    เป็นเกมส์แนวผจญภัยพร้อมเรื่อราวและภารกิจต่าง ๆ ที่สอดแทรกประวัติศาสตร์ได้อย่างน่าเหลือเชื่อ
                  </CardText>
                  <CardLink outline color="primary" href="https://www.youtube.com/watch?v=AdLt8ZcyCqA">Start</CardLink>
                  <CardLink href="#">คำอธิบาย</CardLink>
                </CardBody>
              </Card>
              </CardDeck>

          </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>
          <NavLink href="https://surasak783023869.wordpress.com/">
            ช่องทางการติดต่อ
          </NavLink>
        </div>
      </div>
    );
  }
}

export default Minigame;
